import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

function syncAuthenticationHeader() {
  const token = localStorage.getItem('mantraz_auth_token');
  if (token) {
    axiosInstance.defaults.headers.common.Authentication = token;
  }
}

/**
 * Membuat service CRUD standar untuk satu endpoint master.
 * @param {string} endpoint - Path endpoint, mis. '/master/notification_recipient'
 * @return {object} Service dengan method get/create/update/delete
 */
export default function createCrudService(endpoint) {
  return {
    get(params = {}) {
      syncAuthenticationHeader();
      return axiosInstance.get(endpoint, {
        params,
        cancelToken: getNewCancelToken(),
      });
    },
    create(data) {
      syncAuthenticationHeader();
      return axiosInstance.post(endpoint, data, {
        cancelToken: getNewCancelToken(),
      });
    },
    update(id, data) {
      syncAuthenticationHeader();
      return axiosInstance.put(`${endpoint}/${id}`, data, {
        cancelToken: getNewCancelToken(),
      });
    },
    delete(id) {
      syncAuthenticationHeader();
      return axiosInstance.delete(`${endpoint}/${id}`, {
        cancelToken: getNewCancelToken(),
      });
    },
  };
}
